import { moneyFormat } from "./common";
import { setItem } from "./storage";

export async function afterGetInvoiceMsg(vm, data) {
  await setItem("accountInvoiceMsg", data);
  await vm.$store.dispatch("setAccountInvoiceMsg", data);

  vm.$router.push({
    path: "/invoicemsg",
  });
}

export function handleInvoiceResult(data) {
  const KPRQ = data.KPRQ;
  const KPRQFormat =
    KPRQ.substring(0, 4) +
    "年" +
    KPRQ.substring(4, 6) +
    "月" +
    KPRQ.substring(6, 8) +
    "日";
  return [
    {
      name: "发票代码",
      value: data.FPDM,
    },
    {
      name: "发票号码",
      value: data.FPHM,
    },
    {
      name: "购方名称",
      value: data.GFMC,
    },
    {
      name: "购方税号",
      value: data.GFSH,
    },
    {
      name: "销方名称",
      value: data.XFMC,
    },
    {
      name: "销方税号",
      value: data.XFSH,
    },
    {
      name: "价税合计",
      value: moneyFormat(data.JSHJ),
    },
    {
      name: "开票日期",
      value: KPRQFormat,
    },
    {
      name: "备注",
      value: data.BZ,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/utils/invoice.js